import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	projectsSelectGroup: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentProjectsSelectGroup: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userSelectGroup: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userSelectHelperText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsSelectGroupGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentProjectsSelectGroupGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	projectsSelectGroup: {
		id: 'board-location-dialogs.common.location-picker.projects-select-group',
		defaultMessage: 'Projects',
		description: 'Select dropdown group heading for all project locations.',
	},
	recentProjectsSelectGroup: {
		id: 'board-location-dialogs.common.location-picker.recent-projects-select-group',
		defaultMessage: 'Recent projects',
		description: 'Select dropdown group heading for all recent project locations.',
	},
	userSelectGroup: {
		id: 'board-location-dialogs.common.location-picker.user-select-group',
		defaultMessage: 'Your profile',
		description: 'Select dropdown group heading for the current user location.',
	},
	userSelectHelperText: {
		id: 'board-location-dialogs.common.location-picker.user-select-group-input-helper',
		defaultMessage: 'The board’s URL will change to match this location.',
		description: 'Helper text for the Select dropdown',
	},
	projectsSelectGroupGalaxia: {
		id: 'board-location-dialogs.common.location-picker.projects-select-group-galaxia',
		defaultMessage: 'Spaces',
		description: 'Select dropdown group heading for all project locations.',
	},
	recentProjectsSelectGroupGalaxia: {
		id: 'board-location-dialogs.common.location-picker.recent-projects-select-group-galaxia',
		defaultMessage: 'Recent spaces',
		description: 'Select dropdown group heading for all recent project locations.',
	},
});
export default messages;
